export default __webpack_public_path__ + "static/media/hospital-hd2.44a32b5f.jpg";